module.exports = __webpack_public_path__ + "static/media/Item_Frame@3x.9f5d6980.png";